<template>
  <section v-on:click="sectionClicked"
    :class="{filterOpen: filterOpen}">
    <Header class="scrolled uncorupted" ref="header"
      :merchandise="true"/>
    <McHeader class="scrolled filter" :class="{filterOpen: filterOpen}"
      title="Produk UNCORRUPTED" ref="mcHeader"/>
    <div class="filterToggleMobile" v-on:click="filterOpen = !filterOpen"></div>
    <div class="filterCnt">
      <div class="filterTitle">
        <span>Filter</span>
        <div class="filterToggle" v-on:click="filterOpen = !filterOpen"></div>
      </div>
      <perfect-scrollbar class="filterSc">
        <div class="loadingFilter" v-if="loadingFilter"></div>
        <div v-else>
          <div class="filterSection" :class="{collapsed: filter.category.collapsed}"
            v-on:click="filter.category.collapsed = !filter.category.collapsed">
            <h4>Kategori</h4>
            <div class="filterItem" v-for="(item, i) in filterCategory" :key="i"
              :class="{selected: item.selected}"
              v-on:click.stop="selectFilter(item)">
              <div class="checkbox" :class="{selected: item.selected}"></div>
              {{item.label}}
              <div class="subSection" v-on:click.stop="doNothing"
                v-if="item.subcategories && item.subcategories.length > 0">
                <div class="filterItem" v-for="(item2, i2) in item.subcategories" :key="i2"
                  :class="{selected: item2.selected}"
                  v-on:click.stop="selectFilter(item2)">
                  <div class="checkbox" :class="{selected: item2.selected}"></div>
                  {{item2.label}}
                  <div class="subSection" v-on:click.stop="doNothing"
                    v-if="item2.subcategories && item2.subcategories.length > 0">
                    <div class="filterItem" v-for="(item3, i3) in item2.subcategories" :key="i3"
                      :class="{selected: item3.selected}"
                      v-on:click.stop="selectFilter(item3)">
                      <div class="checkbox" :class="{selected: item3.selected}"></div>
                      {{item3.label}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filterSection" :class="{collapsed: filter.edition.collapsed}"
            v-on:click="filter.edition.collapsed = !filter.edition.collapsed">
            <h4>Edisi</h4>
            <div class="filterItem" v-for="(item, i) in filterEdition" :key="i"
              :class="{selected: item.selected}"
              v-on:click.stop="selectFilter(item)">
              <div class="checkbox" :class="{selected: item.selected}"></div>
              {{item.label}}
            </div>
          </div>
          <div class="filterSection" :class="{collapsed: filter.priceRange.collapsed}"
            v-on:click="filter.priceRange.collapsed = !filter.priceRange.collapsed">
            <h4>Range Harga</h4>
            <div class="filterRange" v-on:click.stop="doNothing">
              <div class="rangeItem r1">
                <input type="number" class="field" placeholder="Harga min"
                  v-model="filterPriceRange.min">
              </div>
              <div class="rangeItem r2">
                <input type="number" class="field" placeholder="Harga max"
                  v-model="filterPriceRange.max">
              </div>
            </div>
            <button class="btn primary sm" type="button"
              v-on:click.stop="filterChanged">Apply</button>
          </div>
          <div class="filterSection" :class="{collapsed: filter.color.collapsed}"
            v-on:click="filter.color.collapsed = !filter.color.collapsed">
            <h4>Warna</h4>
            <div class="filterItem color" v-for="(item, i) in filterColor" :key="i"
              :class="{selected: item.selected}"
              v-on:click.stop="selectFilter(item)">
              <div class="checkbox" :class="{selected: item.selected}"></div>
              <div class="color" :style="{'background-color': item.color}"></div>
              {{item.label}}
            </div>
          </div>
          <div class="filterAction">
            <button class="secondary" v-on:click="cancelFilter">Batal</button>
            <button v-on:click="filterOpen = true">Tetapkan Filter</button>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="itemCnt">
      <div class="itemOk">
        <div class="searchCnt">
          <form v-on:submit.prevent="search">
            <div class="searchIcon"></div>
            <input type="text" placeholder="Tulis pencarianmu disini..."
              v-model="q" v-on:input="search">
          </form>
          <div class="sortBy">
            <div class="sortByBtn" v-on:click.stop="showSortOptions = !showSortOptions">
              <div class="sortIcon"></div>
              <span>Urut berdasarkan: </span>
              <b>{{sortOptions[selectedSort].label}}</b>
            </div>
            <div class="sortByOptions" v-if="showSortOptions"
              v-on:click.stop="doNothing">
              <li v-for="(item, i) in sortOptions" :key="i"
                v-on:click.stop="selectSort(i)"
                :class="{selected: selectedSort === i}">
                {{item.label}}</li>
            </div>
          </div>
        </div>
        <div class="subCategoryCnt" v-if="category
          && category.submenu && category.submenu.length > 0">
          <a :href="`/${item.slug}`"
            class="subCategoryItem" v-for="(item, i) in category.submenu" :key="i">
            <div class="subCategoryImg hasImg" v-if="item.media"
              :style="{'background-image': `url(${item.media.imageMd})`}"></div>
            <div class="subCategoryImg noImg" v-else>
            </div>
            {{item.name}}
          </a>
        </div>
        <div class="selectedFilter" v-if="allFilter.length > 0">
          <div class="selectedFilterItem" v-for="(filter, i) in allFilter" :key="i"
            v-on:click="deselectFilter(i, filter)">
            {{filter.label}}
          </div>
          <div class="selectedFilterItem clearFilter"
            v-on:click="resetFilter">Reset semua filter</div>
        </div>
        <div class="loading" v-if="loading">
          <div class="progress">
            <div class="indeterminate"></div>
          </div>
        </div>
        <div class="notFoundCnt" v-else-if="results.length < 1">
          <div class="notFound">
            <img src="../assets/trash-empty.png">
            <h2>Tidak ada data untuk ditampilkan</h2>
            <p>Periksa kembali filter atau kata kunci pencarian kamu</p>
          </div>
        </div>
        <div class="productCnt" v-else>
          <div class="productItem" v-for="(item, i) in results" :key="i">
            <div class="productItemIn">
              <a :href="`/uncorupted/product/${item.code}`">
                <div class="productImg" v-if="item.images.length > 0 && item.images[0].media"
                  :style="{'background-image': `url(${item.images[0].media.imageSm})`}">
                </div>
                <div class="productImg noImg" v-else></div>
              </a>
              <div class="type" v-if="item.category">{{item.category.name}}</div>
              <h4><a :href="`/uncorupted/product/${item.code}`">{{item.name}}</a></h4>
              <div class="priceCnt">
                <div class="priceDiscount" v-if="item.discount">
                  Rp {{item.discountedPrice.toLocaleString('id')}}
                </div>
                <div class="price">Rp {{item.sellPrice.toLocaleString('id')}}</div>
              </div>
              <div class="productAction">
                <div class="love" :class="{loved: item.inWishlist}"
                  v-on:click="addToWishlist(i, item)"></div>
                <div class="outOfStock" v-if="item.inStock < 1">Stock habis</div>
                <div class="addToCart" v-else v-on:click="addToCart(i, item)">Lihat
                  <span>produk</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="copyright">&copy; Copyright {{d.getFullYear()}}
        Sahabat ICW. All right reserved.</div>
      </div>
    </div>
    <AddedToCart ref="addedToCart"/>
    <Snackbar ref="snackbar"/>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import McHeader from '@/components/McHeader.vue';
import AddedToCart from '@/components/AddedToCart.vue';
import Snackbar from '@/components/Snackbar.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: {
    Header,
    McHeader,
    AddedToCart,
    Snackbar,
    Confirmation,
  },
  data() {
    return {
      loading: false,
      results: [],
      category: null,
      allYear: [],
      year: null,
      currentYear: 0,
      city: '',
      country: '',
      inPage: true,
      singingAl: true,
      uuid: '',
      minYear: 2021,
      loadingMore: false,
      canLoadMore: true,
      page: 0,
      total: 0,
      parentSlug: '',
      loadingFilter: true,
      d: new Date(),

      /**
       * Search and sorting
       *
       */
      q: '',
      searchTimer: null,
      showSortOptions: false,
      selectedSort: 0,
      sortOptions: [
        { value: 'dateAsc', label: 'Terbaru' },
        { value: 'dateDesc', label: 'Terlama' },
        { value: 'priceAsc', label: 'Termurah' },
        { value: 'priceDesc', label: 'Termahal' },
      ],

      /**
       * Filter
       *
       */
      filterOpen: true,
      allFilter: [],
      filter: {
        category: { collapsed: false },
        edition: { collapsed: true },
        priceRange: { collapsed: true },
        color: { collapsed: true },
      },
      filterColor: [],
      filterEdition: [],
      filterCategory: [],
      filterPriceRange: { min: '', max: '' },
    };
  },
  methods: {
    doNothing() {},
    addToCart(i, item) {
      if (!this.$session.get('shb_icw_logged_in')) {
        this.$refs.mcHeader.openAccount();
        return;
      }
      if (item.inStock < 1) {
        this.$refs.confirmDialog.open({
          title: 'Produk tidak tersedia',
          desc: 'Untuk sekarang produk ini sedang tidak tersedia, silahkan cek kembali lagi nanti',
          action: 'Tutup',
          confirm: false,
        });
        return;
      }
      this.$router.push(`/uncorupted/product/${item.code}`);
      // this.$refs.addedToCart.open(1, item, (b) => {
      //   if (!b) return;
      //   this.$refs.mcHeader.openCart();
      // });
    },
    addToWishlist(i, item) {
      if (!this.$session.get('shb_icw_logged_in')) {
        this.$refs.mcHeader.openAccount();
        return;
      }
      if (item.inWishlist) {
        item.inWishlist = false; // eslint-disable-line
        this.$http.post(this.$config.uri('user/wishlist/remove'), {
          productId: item.id,
        }).then((r) => {
          this.$refs.mcHeader.countWishlist();
          this.$refs.snackbar.open({
            content: `${item.name} dihapus dari daftar favorit`,
          });
        });
        return;
      }
      item.inWishlist = true; // eslint-disable-line
      this.$http.post(this.$config.uri('user/wishlist'), {
        productId: item.id,
      }).then((r) => {
        this.$refs.mcHeader.countWishlist();
        this.$refs.snackbar.open({
          content: `${item.name} ditambahkan ke daftar favorit`,
        });
      });
    },
    selectFilter(item) {
      // eslint-disable-next-line
      item.selected = !item.selected;
      this.filterChanged();
    },
    openItem(item, i) {
      this.$router.push(`/${item.category.slug}/${item.slug}`);
    },
    tagClicked(tag) {
      const tagEncoded = encodeURI(tag.replaceAll('#', ''));
      window.location.href = `/${this.parentSlug}?hashtags=${tagEncoded}`;
    },
    search() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getData();
      }, 500);
    },
    sectionClicked() {
      this.showSortOptions = false;
      if (this.$refs.header) this.$refs.header.headerClicked();
      if (this.$refs.mcHeader) this.$refs.mcHeader.headerClicked();
    },
    selectSort(i) {
      this.selectedSort = i;
      this.showSortOptions = false;
      this.getData();
    },
    signAnalytic() {
      if (!this.inPage) {
        this.singingAl = false;
        return;
      }
      this.singingAl = true;
      const alUri = `misc/al/home/${this.category.id}?session=${this.sessionId}&uuid=${this.uuid}`;
      this.$http.post(this.$config.uri(alUri), {
        city: this.city,
        country: this.country,
      }).then((r) => {
        setTimeout(() => {
          this.singingAl = false;
          this.signAnalytic();
        }, 5000);
      });
    },
    windowFocused() {
      this.inPage = true;
      if (!this.singingAl) this.signAnalytic();
    },
    windowBlured() {
      this.inPage = false;
    },
    resetFilter() {
      this.allFilter = [];
      // eslint-disable-next-line
      for (const item of this.filterCategory) {
        item.selected = false;
        if (item.subcategories && item.subcategories.length > 0) {
          // eslint-disable-next-line
          for (const item2 of item.subcategories) {
            item2.selected = false;
            if (item2.subcategories && item2.subcategories.length > 0) {
              // eslint-disable-next-line
              for (const item3 of item2.subcategories) {
                item3.selected = false;
              }
            }
          }
        }
      }
      // eslint-disable-next-line
      for (const item of this.filterEdition) {
        item.selected = false;
      }
      // eslint-disable-next-line
      for (const item of this.filterColor) {
        item.selected = false;
      }

      this.filterPriceRange.min = '';
      this.filterPriceRange.max = '';

      const url = new URL(window.location);
      url.searchParams.set('ctr', '');
      url.searchParams.set('ed', '');
      url.searchParams.set('color', '');
      window.history.replaceState(null, null, url);

      this.getData();
    },
    deselectFilter(i, filter) {
      if (filter.type === 'category') {
        // eslint-disable-next-line
        for (const item of this.filterCategory) {
          if (item.value === filter.value && item.selected) {
            item.selected = false;
          }
          if (item.subcategories && item.subcategories.length > 0) {
            // eslint-disable-next-line
            for (const item2 of item.subcategories) {
              if (item2.value === filter.value && item2.selected) {
                item2.selected = false;
              }
              if (item2.subcategories && item2.subcategories.length > 0) {
                // eslint-disable-next-line
                for (const item3 of item2.subcategories) {
                  if (item3.value === filter.value && item3.selected) {
                    item3.selected = false;
                  }
                }
              }
            }
          }
        }
      } else if (filter.type === 'edition') {
        // eslint-disable-next-line
        for (const item of this.filterEdition) {
          if (item.value === filter.value && item.selected) {
            item.selected = false;
          }
        }
      } else if (filter.type === 'color') {
        // eslint-disable-next-line
        for (const item of this.filterColor) {
          if (item.value === filter.value && item.selected) {
            item.selected = false;
          }
        }
      } else if (filter.type === 'priceRange') {
        this.filterPriceRange.min = '';
        this.filterPriceRange.max = '';
      }

      this.filterChanged();
    },
    cancelFilter() {
      this.resetFilter();
      this.filterOpen = true;
    },
    filterChanged() {
      this.allFilter = [];
      const catQuery = [];
      // eslint-disable-next-line
      for (const item of this.filterCategory) {
        if (item.selected) {
          catQuery.push(item.value);
          this.allFilter.push({
            type: 'category',
            value: item.value,
            label: `Kategori: ${item.label}`,
          });
        }
        if (item.subcategories && item.subcategories.length > 0) {
          // eslint-disable-next-line
          for (const item2 of item.subcategories) {
            if (item2.selected) {
              catQuery.push(item2.value);
              this.allFilter.push({
                type: 'category',
                value: item2.value,
                label: `Kategori: ${item2.label}`,
              });
            }
            if (item2.subcategories && item2.subcategories.length > 0) {
              // eslint-disable-next-line
              for (const item3 of item2.subcategories) {
                if (item3.selected) {
                  catQuery.push(item3.value);
                  this.allFilter.push({
                    type: 'category',
                    value: item3.value,
                    label: `Kategori: ${item3.label}`,
                  });
                }
              }
            }
          }
        }
      }

      const editionQuery = [];
      // eslint-disable-next-line
      for (const item of this.filterEdition) {
        if (item.selected) {
          editionQuery.push(item.value);
          this.allFilter.push({
            type: 'edition',
            value: item.value,
            label: `Edisi: ${item.label}`,
          });
        }
      }

      const colorQuery = [];
      // eslint-disable-next-line
      for (const item of this.filterColor) {
        if (item.selected) {
          colorQuery.push(item.value);
          this.allFilter.push({
            type: 'color',
            value: item.value,
            label: `Warna: ${item.label}`,
          });
        }
      }

      if (this.filterPriceRange.min && this.filterPriceRange.max) {
        this.allFilter.push({
          type: 'priceRange',
          value: `${this.filterPriceRange.min} - ${this.filterPriceRange.min}`,
          label: `Range harga: Rp ${this.filterPriceRange.min.toLocaleString('id')}
            - Rp ${this.filterPriceRange.max.toLocaleString('id')}`,
        });
      } else if (this.filterPriceRange.min) {
        this.allFilter.push({
          type: 'priceRange',
          value: `>= ${this.filterPriceRange.min}`,
          label: `Range harga: >= ${this.filterPriceRange.min.toLocaleString('id')}`,
        });
      } else if (this.filterPriceRange.max) {
        this.allFilter.push({
          type: 'priceRange',
          value: `<= ${this.filterPriceRange.max}`,
          label: `Range harga: <= ${this.filterPriceRange.max.toLocaleString('id')}`,
        });
      }

      const catQueryStr = catQuery.join(';');
      const editionQueryStr = editionQuery.join(';');
      const colorQueryStr = colorQuery.join(';');
      const url = new URL(window.location);
      url.searchParams.set('cat', catQueryStr);
      url.searchParams.set('ed', editionQueryStr);
      url.searchParams.set('color', colorQueryStr);
      window.history.replaceState(null, null, url);

      this.getData();
    },
    getData() {
      this.loading = true;
      const sort = this.sortOptions[this.selectedSort].value;
      this.$http.post(this.$config.uri(`product/all?q=${this.q}&sort=${sort}`), {
        filter: this.allFilter,
      }).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
      });
    },
    loadMore() {
      const { parent } = this.$route.params;
      if (parent === 'amagram' || parent === 'amagram-internal'
        || parent === 'leaders-newsletter' || parent === 'bulletin') {
        this.loadingMore = false;
        return;
      }
      if (!this.category) {
        this.loadingMore = false;
        return;
      }
      const year = (this.$route.params.year && this.$route.params.year !== 'all')
        ? `&year=${this.$route.params.year}` : '';
      this.page += 1;
      this.$http.post(this.$config.uri(`content/all?parentId=${this.category.id}${year}&limit=12&page=${this.page}`), {
        filter: this.allFilter,
      }).then((rr) => {
        this.loadingMore = false;
        if (rr.data.status !== 200) {
          this.canLoadMore = false;
          return;
        }
        this.results.push(...rr.data.data);
      });
    },
    getCategories() {
      this.$http.get(this.$config.uri('product/filter/category')).then((rct) => {
        this.filterCategory = (rct.data.status === 200) ? rct.data.data : [];
        this.$http.get(this.$config.uri('product/filter/edition')).then((red) => {
          this.filterEdition = (red.data.status === 200) ? red.data.data : [];
          this.$http.get(this.$config.uri('product/filter/color')).then((rst) => {
            this.loadingFilter = false;
            this.filterColor = (rst.data.status === 200) ? rst.data.data : [];
            if (this.$route.query.ctr && this.$route.query.ctr !== '') {
              const ctr = decodeURIComponent(this.$route.query.ctr);
              const ctrs = ctr.split(';');
              // eslint-disable-next-line
              for (const item of ctrs) {
                // eslint-disable-next-line
                for (const c of this.filterCategory) {
                  if (c.value === parseInt(item, 10)) {
                    // eslint-disable-next-line
                    c.selected = true;
                    this.allFilter.push({
                      type: 'category',
                      value: c.value,
                      label: `Kategori: ${c.label}`,
                    });
                  }
                  if (c.subcategories && c.subcategories.length > 0) {
                    // eslint-disable-next-line
                    for (const c2 of c.subcategories) {
                      if (c2.value === parseInt(item, 10)) {
                        // eslint-disable-next-line
                        c2.selected = true;
                        this.allFilter.push({
                          type: 'category',
                          value: c2.value,
                          label: `Kategori: ${c2.label}`,
                        });
                      }
                      if (c2.subcategories && c2.subcategories.length > 0) {
                        // eslint-disable-next-line
                        for (const c3 of c2.subcategories) {
                          if (c3.value === parseInt(item, 10)) {
                            // eslint-disable-next-line
                            c3.selected = true;
                            this.allFilter.push({
                              type: 'category',
                              value: c3.value,
                              label: `Kategori: ${c3.label}`,
                            });
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            if (this.$route.query.ed && this.$route.query.ed !== '') {
              const ed = decodeURIComponent(this.$route.query.ed);
              const eds = ed.split(';');
              // eslint-disable-next-line
              for (const item of eds) {
                // eslint-disable-next-line
                for (const c of this.filterEdition) {
                  if (c.value === parseInt(item, 10)) {
                    // eslint-disable-next-line
                    c.selected = true;
                    this.allFilter.push({
                      type: 'edition',
                      value: c.value,
                      label: `Edisi: ${c.label}`,
                    });
                  }
                }
              }
            }
            if (this.$route.query.color && this.$route.query.color !== '') {
              const color = decodeURIComponent(this.$route.query.color);
              const colors = color.split(';');
              // eslint-disable-next-line
              for (const item of colors) {
                // eslint-disable-next-line
                for (const c of this.filterEdition) {
                  if (c.value === item) {
                    // eslint-disable-next-line
                    c.selected = true;
                    this.allFilter.push({
                      type: 'color',
                      value: c.value,
                      label: `Wana: ${c.label}`,
                    });
                  }
                }
              }
            }
            this.getData();
          });
        });
      });
    },
    windowScrolled() {
      // const reachBot = document.documentElement.scrollTop + window.innerHeight
      //   >= document.documentElement.offsetHeight -
      // (document.getElementById('footer').clientHeight
      //   + 400);
      // if (reachBot && !this.loadingMore && this.canLoadMore) {
      //   this.loadingMore = true;
      //   this.loadMore();
      // }
    },
  },
  created() {
    window.addEventListener('focus', this.windowFocused);
    window.addEventListener('blur', this.windowBlured);
    window.addEventListener('scroll', this.windowScrolled);
    document.getElementsByTagName('BODY')[0].classList.add('hideFooter');
  },
  destroyed() {
    window.removeEventListener('focus', this.windowFocused);
    window.removeEventListener('blur', this.windowBlured);
    window.removeEventListener('scroll', this.windowScrolled);
    document.getElementsByTagName('BODY')[0].classList.remove('hideFooter');
  },
  beforeDestroy() {
    this.inPage = false;
  },
  mounted() {
    this.inPage = true;
    document.title = this.$config.appName;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.sessionId = sessionStorage.getItem('sessionId');
    this.parentSlug = this.$route.params.parent;

    this.q = this.$route.query.q || '';
    const { hashtags } = this.$route.query;
    if (hashtags && hashtags !== '') {
      const hs = hashtags.split(';');
      // eslint-disable-next-line
      for (const item of hs) {
        this.q = (this.q && this.q !== '')
          ? `${this.q} #${item}` : `#${item}`;
      }
    }

    this.getCategories();
  },
};
</script>

<style scoped lang="scss">
.selectedFilter{
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px 16px;
  .selectedFilterItem{
    padding: 5px 10px 4px;
    border-radius: 3px;
    border: #a7cbf2 1px solid;
    color: #012f5f;
    background-color: #f0f7ff;
    margin: 0 6px 6px 0;
    font-size: 12px;
    padding-right: 26px;
    position: relative;
    cursor: pointer;
    transition: all .3s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 260px;
    &:hover{
      border-color: #6d94bf;
      background-color: #e2f1ff;
    }
    &:before{
      content: "";
      position: absolute;
      right: 6px; top: 5px;
      width: 15px; height: 15px;
      border-radius: 50%;
      background-color: #a7cbf2;
      background-image: url(../assets/close.png);
      background-size: 6px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    &.clearFilter{
      background-color: #fff;
      border-color: #fff;
      cursor: pointer;
      // font-weight: 600;
      transition: all .3s ease;
      padding-right: 10px;
      &:before{
        display: none;
      }
      &:hover{
        background-color: #002f5f;
        color: #fff;
      }
    }
  }
}

.filterToggleMobile{
  position: fixed;
  left: 16px; bottom: 20px;
  z-index: 97;
  width: 50px; height: 50px;
  background-color: #035fae;
  background-image: url(../assets/filter-white.png);
  background-size: 22px auto;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  cursor: pointer;
  transition: all .3s ease;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, .3);
  display: none;
  @media (max-width: 680px) {
    display: block;
  }
}
.filterCnt{
  position: fixed;
  top: 76px; left: 0; bottom: 0;
  width: 50px;
  border-right: #eee 1px solid;
  background-color: #fff;
  z-index: 97;
  @media (max-width: 1140px) {
    transition: all .3s ease;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    width: 300px;
  }
  @media (max-width: 760px) {
    top: 60px;
  }
  .filterSc{
    position: absolute;
    top: 49px; left: 0; right: 0; bottom: 0;
    overflow-y: auto;
    padding-bottom: 120px;
    display: none;
    .loadingFilter{
      height: 200px;
      background-image: url(../assets/loading.svg);
      background-size: 36px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    @media (max-width: 1140px) {
      transition: all .3s ease;
      display: block;
      opacity: 1;
    }
  }
  .filterTitle{
    font-size: 20px;
    border-bottom: #eee 1px solid;
    font-weight: 400;
    position: relative;
    height: 45px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    @media (max-width: 1140px) {
      padding: 14px 20px 8px;
    }
    span{
      display: none;
      @media (max-width: 1140px) {
        display: inline-block;
      }
    }
    .filterToggle{
      position: absolute;
      right: 10px; top: 6px;
      width: 30px; height: 30px;
      background-image: url(../assets/arrow-right.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      cursor: pointer;
      transition: all .3s ease;
      @media (max-width: 1140px) {
        background-image: url(../assets/arrow-left.png);
      }
      &:hover{
        background-color: #eee;
      }
    }
  }
  .filterSection{
    padding: 10px 20px 20px;
    // border-bottom: #eee 1px solid;
    margin: 10px 0 0;
    position: relative;
    cursor: pointer;
    &.withHeader{
      padding-bottom: 30px;
    }
    &:before{
      content: "";
      position: absolute;
      width: 30px; height: 30px;
      border-radius: 50%;
      right: 10px; top: 5px;
      background-image: url(../assets/up-arrow.png);
      background-size: 12px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      // background-color: red;
    }
    &:hover{
      &:before{
        background-color: #eee;
      }
    }
    h4{
      font-size: 16px;
      font-weight: 400;
      margin: 0 0 10px;
      &.withHeader{
        margin-bottom: 0;
      }
    }
    .filterRange{
      display: flex;
      padding: 6px 0 10px;
      .rangeItem{
        width: 50%;
        box-sizing: border-box;
        &.r1{
          padding-right: 5px;
        }
        &.r2{
          padding-left: 5px;
        }
        .field{
          padding: 8px 10px;
          box-sizing: border-box;
          font-size: 14px;
          width: 100%;
          border-radius: 3px;
          border: #ccc 1px solid;
        }
      }
    }
    .btn{
      width: 100%;
    }
    .filterDate{
      display: flex;
      padding: 6px 0;
      .field{
        padding: 8px 6px;
        font-size: 14px;
        text-align: center;
      }
      .fdDate{
        width: 25%;
      }
      .fdMonth{
        width: calc(35% - 16px);
        margin: 0 auto;
      }
      .fdYear{
        width: 40%;
      }
    }
    .filterItem{
      position: relative;
      padding: 6px 0;
      padding-left: 30px;
      font-size: 15px;
      color: #444;
      &.color{
        padding-left: 58px;
        .color{
          width: 18px; height: 18px;
          border-radius: 3px;
          position: absolute;
          left: 30px; top: 6px;
        }
      }
      .count{
        float: right;
        color: #767676;
        font-size: 12px;
        padding-top: 2px;
        width: 20px; height: 20px;
        background-color: #f5f5f5;
        text-align: center;
        box-sizing: border-box;
        border-radius: 50%;
      }
      &.header{
        cursor: default;
        text-transform: uppercase;
        font-weight: 500;
        padding: 14px 0 4px;
        font-size: 13px;
        color: #767676 !important;
      }
      &.viewMore{
        color: #115457;
        padding-left: 0;
        margin-top: 2px;
        font-size: 14px;
        display: none;
        img{
          height: 13px;
          margin: 2px 8px -2px 0;
          float: left;
        }
        &:hover{
          color: #035fae;
        }
      }
      .checkbox{
        left: 0; top: 6px; margin: 0;
        // width: 16px; height: 16px;
        // position: absolute;
        // left: 0; top: 15px;
        // border: #999 2px solid;
        // border-radius: 3px;
        // background-size: 14px auto;
        // background-position: center;
        // background-repeat: no-repeat;
        &.selected{
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #035fae;
          border-color: #035fae;
          background-image: url(../assets/checked.png);
        }
      }
      &:hover{
        color: #035fae;
        .checkbox{
          // border-color: #222;
        }
      }
      .subSection{
        margin: 10px 0 10px -21px;
        padding-left: 20px;
        border-left: #ccc 1px solid;
      }
    }
    &.collapsed{
      &:before{
        transform: rotate(180deg);
      }
      .filterDate{
        display: none;
      }
      .filterItem{
        display: none;
      }
      .filterRange{
        display: none;
      }
      .btn{
        display: none;
      }
    }
  }
  .filterAction{
    text-align: right;
    padding: 10px 20px;
    border-top: #eee 1px solid;
    display: none;
    @media (max-width: 680px) {
      display: block;
    }
    button{
      margin-left: 10px;
    }
  }
}
.itemCnt{
  margin-left: 50px;
  margin-top: 134px;
  @media (max-width: 680px) {
    margin-left: 0;
    padding-bottom: 60px;
  }
  .itemOk{
    margin: 0 auto;
    max-width: 1480px;
  }
}
.copyright{
  text-align: center;
  padding: 40px 0 20px;
  font-size: 14px;
  color: #767676;
}
.filterOpen{
  .filterCnt{
    width: 301px;
    @media (max-width: 1140px) {
      left: -250px;
      box-shadow: none;
    }
    @media (max-width: 680px) {
      left: -300px;
    }
    .filterTitle{
      padding: 11px 20px 0;
      padding-left: 48px;
      @media (max-width: 680px) {
        padding-left: 0;
      }
      &:before{
        position: absolute;
        top: 0; bottom: 0; left: 20px;
        width: 17px;
        content: ""; display: block;
        background-image: url(../assets/filter.png);
        background-size: 17px auto;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 680px) {
          display: none;
        }
      }
      span{
        display: inline-block;
      }
      .filterToggle{
        background-image: url(../assets/arrow-left.png);
        @media (max-width: 1140px) {
          background-image: url(../assets/filter.png);
        }
      }
    }
    .filterSc{
      display: block;
      @media (max-width: 1140px) {
        opacity: 0;
      }
    }
  }
  .itemCnt{
    margin-left: 300px;
    @media (max-width: 1140px) {
      margin-left: 50px;
    }
    @media (max-width: 680px) {
      margin-left: 0;
    }
  }
}

.searchCnt{
  padding: 0 20px 20px;
  display: flex;
  @media (max-width: 680px) {
    padding: 0 16px 20px;
  }
  form{
    position: relative;
    width: calc(100% - 300px);
    @media (max-width: 1260px) {
      width: calc(100% - 260px);
    }
    @media (max-width: 760px) {
      width: calc(100% - 50px);
    }
    @media (max-width: 680px) {
    }
    .searchIcon{
      position: absolute;
      left: 10px; top: 0; bottom: 2px;
      z-index: 3; width: 30px;
      background-image: url(../assets/search.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    input{
      padding: 10px 14px 11px;
      width: 100%;
      border-radius: 5px;
      box-sizing: border-box;
      border: #ccc 1px solid;
      padding-left: 46px;
      font-weight: 400;
      font-size: 14px;
      background-color: #fff;
      &:hover{
        border-color: #222;
      }
    }
  }
  .sortBy{
    width: 300px;
    box-sizing: border-box;
    padding-left: 20px;
    position: relative;
    font-weight: 300;
    @media (max-width: 1260px) {
      width: 260px;
    }
    @media (max-width: 760px) {
      width: 70px;
    }
    @media (max-width: 680px) {
      width: 66px;
      padding-left: 16px;
    }
    b{
      font-weight: 400;
    }
    .sortByBtn{
      border: #ccc 1px solid;
      border-radius: 5px;
      height: 100%;
      padding: 10px 16px 0;
      padding-right: 44px;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      box-sizing: border-box;
      text-overflow: ellipsis;
      cursor: pointer;
      padding-left: 46px;
      position: relative;
      &:hover{
        border-color: #222;
      }
      @media (max-width: 760px) {
        padding: 0;
        width: 50px;
      }
      span{
        color: #767676;
        @media (max-width: 1260px) {
          display: none;
        }
      }
      b{
        color: #444;
        font-weight: 600;
        @media (max-width: 760px) {
          display: none;
        }
      }
      .sortIcon{
        position: absolute;
        left: 16px; top: 0; bottom: 2px;
        width: 20px;
        background-image: url(../assets/sort.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &:before{
        content: "";
        position: absolute;
        right: 16px; top: 0; bottom: 0; width: 14px;
        opacity: .65;
        background-image: url(../assets/down-arrow.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 760px) {
          display: none;
        }
      }
    }
    .sortByOptions{
      position: absolute;
      right: 0; top: 100%;
      background-color: #fff;
      padding: 10px 0;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      border-radius: 5px;
      border: #eee 1px solid;
      z-index: 9;
      min-width: calc(100% - 20px);
      box-sizing: border-box;
      li{
        list-style: none;
        padding: 10px 24px;
        cursor: pointer;
        transition: all .3s ease;
        font-weight: 400;
        white-space: nowrap;
        &:hover{
          background-color: #f5f5fe;
        }
        &.selected{
          background-color: #eee;
        }
      }
    }
  }
}

.loadingMore{
  text-align: center;
  padding: 20px 0 26px;
  color: #767676;
  font-size: 15px;
  .loadingImg{
    height: 36px;
    background-image: url(../assets/loading.svg);
    background-position: center;
    background-size: 36px auto;
    background-repeat: no-repeat;
    margin-bottom: 10px;
  }
}

.prevEdition{
  text-align: center;
  margin-bottom: 40px;
  @media (max-width: 680px) {
    margin-bottom: 20px;
  }
  a{
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    background-color: #002f5f;
    display: inline-block;
    padding: 8px 16px;
    border-radius: 3px;
    border: #002f5f 2px solid;
    transition: all .3s ease;
    &:hover{
      color: #002f5f;
      background-color: #fff;
    }
  }
  &.editionChange{
    display: flex;
    margin: 0 auto 40px;
    max-width: 1180px;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      margin: 0 20px 30px;
    }
    @media (max-width: 680px) {
      margin: 0 16px 20px;
    }
    a{
      color: #002f5f;
      background-color: #fff;
      border-width: 1px;
      display: inline-block;
      position: relative;
      &:before{
        width: 20px;
        left: 10px; top: 0; bottom: 0;
        position: absolute;
        content: "";
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &:hover{
        color: #fff;
        background-color: #002f5f;
      }
      @media (max-width: 680px) {
        span{
          display: none;
        }
      }
    }
    .prev{
      margin-right: auto;
      padding-left: 40px;
      @media (max-width: 680px) {
        padding-left: 36px;
      }
      &:before{
        background-image: url(../assets/left-arrow.png);
      }
      &:hover{
        &:before{
          background-image: url(../assets/left-arrow-white.png);
        }
      }
    }
    .next{
      margin-left: auto;
      padding-right: 40px;
      @media (max-width: 680px) {
        padding-right: 36px;
      }
      &:before{
        right: 10px; left: auto;;
        background-image: url(../assets/right-arrow.png);
      }
      &:hover{
        &:before{
          background-image: url(../assets/right-arrow-white.png);
        }
      }
    }
  }
}
.notFound{
  position: static;
  transform: none;
  padding: 60px 20px 50px;
  border-radius: 10px;
  border: #eee 1px solid;
  margin: 0 20px;
  text-align: center;
  color: #444;
  @media (max-width: 680px) {
    margin: 0 16px;
  }
  img{
    height: auto; width: 100%;
    max-width: 180px;
    margin-bottom: 30px;
    @media (max-width: 680px) {
      max-width: 140px;
    }
  }
  h2{
    margin: 0 0 8px;
    font-size: 22px;
    line-height: 1;
    font-weight: 400;
    @media (max-width: 680px) {
      font-size: 26px;
    }
  }
  p{
    margin: 0;
    color: #767676;
    font-size: 15px;
  }
}

@keyframes indeterminate {
  0% { left: -35%; right: 100%; }
  60% { left: 100%; right: -90%; }
  100% { left: 100%; right: -90%; }
}
@keyframes indeterminate-short {
  0% { left: -200%; right: 100%; }
  60% { left: 107%; right: -8%; }
  100% { left: 107%; right: -8%; }
}
.loading{
  margin: 20px 20px;
  .progress{
    height: 4px;
    background-color: #bbcee8;
    position: relative;
    overflow: hidden;
    .indeterminate {
      background-color: #5184c6;
      &:before{
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0; left: 0; bottom: 0;
        will-change: left, right;
        animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      }
      &:after {
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0;
        left: 0;
        bottom: 0;
        will-change: left, right;
        animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
        animation-delay: 1.15s;
      }
    }
  }
}
.totalItem{
  margin: -10px 20px 20px;
  color: #767676;
}
.sectionTitle{
  font-size: 18px;
  color: #767676;
  margin: 6px 40px;
  text-align: left;
  @media (max-width: 680px) {
    margin: 6px 36px;
  }
}

.subCategoryCnt{
  display: flex;
  margin: 0 10px;
  padding: 0;
  flex-wrap: wrap;
  position: relative;
  z-index: 9;
  .subCategoryItem{
    width: 20%;
    padding: 0 10px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 500;
    margin: 10px 0;
    cursor: pointer;
    display: block;
    color: #444;
    .subCategoryImg{
      height: 12vw;
      background-color: #f5f5f5;
      background-position: center;
      background-size: cover;
      border-radius: 3px;
      margin-bottom: 10px;
      position: relative;
      transition: all .3s ease;
      @media (max-width: 1440px) {
        height: 11vw;
      }
      &.noImg{
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          transition: all .3s ease;
          background-image: url(../assets/directory.png);
          background-size: 64px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .2;
        }
      }
      &:hover{
        background-color: #f5f5fe;
        &:before{
          opacity: .4;
        }
      }
    }
  }
}

.allContentCnt{
  padding: 0 0 20px;
  .allContent{
    margin: 0 20px;
    @media (max-width: 680px) {
      margin: 0 16px;
    }
    .contentCnt{}
    .contentItem{
      border-radius: 10px;
      border: #eee 1px solid;
      margin-bottom: 20px;
      padding: 20px;
      cursor: pointer;
      @media (max-width: 680px) {
        padding: 20px 16px;
      }
      h4{
        margin: 0 0 14px;
        font-size: 24px;
        line-height: 1.3;
        font-family: 'Source Serif Pro', serif;
        font-weight: 400;
        @media (max-width: 680px) {
          font-size: 20px;
          margin: 0 0 10px;
        }
      }
      a{
        color: #444;
        text-decoration: none;
      }
      .labels{
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 4px;
        @media (max-width: 680px) {
          padding-bottom: 7px;
        }
        .label{
          padding: 6px 10px;
          font-size: 13px;
          margin: 0 10px 10px 0;
          background-color: #222;
          color: #fff;
          border-radius: 3px;
          &.category{
            background-color: #212E71;
          }
          &.status{
            background-color: #115457;
          }
          &.subjekHukum{
            background-color: #571010;
            display: none;
          }
          @media (max-width: 680px) {
            margin: 0 5px 5px 0;
            font-size: 12px;
          }
        }
      }
      .tags{
        display: flex;
        flex-wrap: wrap;
        .tag{
          cursor: pointer;
          margin: 0 14px 6px 0;
          color: #115457;
          transition: all .3s ease;
          @media (max-width: 680px) {
            margin: 0 12px 2px 0;
            font-size: 15px;
          }
          &:hover{
            color: #035fae;
          }
        }
      }
      .contentInfo{
        position: relative;
        display: flex;
        @media (max-width: 860px) {
          display: block;
        }
        .contentInfoL{
          width: calc(100% - 300px);
          box-sizing: border-box;
          padding-right: 20px;
          @media (max-width: 860px) {
            width: auto;
            padding-right: 0;
          }
          .contentDesc{
            margin: 0 0 14px;
            @media (max-width: 680px) {
              margin: 0 0 10px;
              font-size: 15px;
            }
          }
        }
        .dateCnt{
          width: 300px;
          border-left: #eee 1px solid;
          box-sizing: border-box;
          padding-left: 20px;
          display: flex;
          flex-wrap: wrap;
          @media (max-width: 860px) {
            width: auto;
            margin-top: 8px;
            padding: 0;
            display: block;
            border: none;
          }
          .date{
            display: flex;
            width: 100%;
            padding: 0 0 8px;
            @media (max-width: 860px) {
              padding: 0 0 6px;
            }
            @media (max-width: 680px) {
              font-size: 15px;
            }
            .dateLabel{
              width: 160px;
              @media (max-width: 680px) {
                width: 140px;
              }
            }
          }
        }
      }
    }
  }
}

.productCnt{
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 0 -10px;
  .productItem{
    width: 20%;
    box-sizing: border-box;
    text-align: center;
    padding: 0 10px 20px;
    margin-bottom: 20px;
    position: relative;
    border: #fff 1px solid;
    border-radius: 5px;
    transition: all .3s ease;
    @media (max-width: 1620px) {
      width: 25%;
    }
    @media (max-width: 1370px) {
      width: 33.33333%;
    }
    @media (max-width: 860px) {
      width: 50%;
    }
    &:hover{
      border-color: #ccc;
    }
    .productItemIn{
      position: relative;
      z-index: 3;
    }
    .productImg{
      height: 240px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 5px;
      margin: 10px 0;
      border: #fff 1px solid;
      @media (max-width: 860px) {
        height: 260px;
      }
      @media (max-width: 640px) {
        height: 180px;
      }
      &.noImg{
        background-image: url(../assets/image-black.png);
        background-size: 46px auto;
        border-color: #ccc;
        opacity: .34;
      }
    }
    .type{
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 600;
      color: #6dc3c8;
    }
    h4{
      margin: 4px 0 6px;
      font-weight: 600;
    }
    .priceCnt{
      display: flex;
      justify-content: center;
      font-size: 14px;
      margin: 0 0 10px;
      @media (max-width: 680px) {
        display: block;
      }
      .priceDiscount{
        margin-right: 10px;
        color: red;
        text-decoration: line-through;
        @media (max-width: 680px) {
          margin: 0 0 2px;
          font-size: 13px;
        }
      }
    }
    .productAction{
      display: flex;
      justify-content: center;
      align-items: center;
      .outOfStock{
        color: #767676;
        background-color: #eee;
        border-radius: 50px;
        font-size: 13px;
        padding: 6px 10px;
      }
      .addToCart{
        font-size: 13px;
        position: relative;
        padding: 6px 10px;
        padding-left: 38px;
        margin-left: 5px;
        cursor: pointer;
        transition: all .3s ease;
        border: #ccc 1px solid;
        border-radius: 50px;
        span{
          @media (max-width: 480px) {
            display: none;
          }
        }
        &:hover{
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        }
        &:before{
          position: absolute;
          left: 6px; top: 0;
          content: "";
          width: 30px; height: 30px;
          background-image: url(../assets/add-to-cart.png);
          background-size: 28px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .love{
        margin-right: 5px;
        width: 30px; height: 30px;
        background-image: url(../assets/heart.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        opacity: .65;
        transition: all .3s ease;
        &.loved{
          background-image: url(../assets/heart-loved.png);
          opacity: 1;
          animation: loved .3s ease;
        }
        &:hover{
          opacity: 1;
        }
      }
    }
  }
}


@keyframes heartAnimation {
  from {
    transform: scale(.4);
  }
  to {
    transform: scale(1.2);
  }
}
@keyframes heartAnimation2 {
  from {
    transform: scale(1.2);
  }
  to {
    transform: scale(1);
  }
}

</style>
